import React from 'react';
import './videos.scss';
import { videoData } from './videoData';
import Video from './Video';

function Videos() {
  return (
    <div className="videos">
      {videoData.map((data, i) => {
        return <Video data={data} key={`video_${data.head}`} />;
      })}
    </div>
  );
}

export default Videos;
